
import Vue from 'vue';
import * as ENDPOINTS from './endpoints';
import { resolveRequestError } from '@/utils/auth';


export default class cryptoServices {
      // ================= function create crypto coin ===================//

  static async createCoin(){
    
    try {
      const {data} = await Vue.http.get(ENDPOINTS.GIFTCARD_TRADES_SUMMARY) ;
      return data
  } catch (error) {
      resolveRequestError(error);
  }
  }
 
  //====================== retrive all coins =============================//
  
  static async getCoins(){
    
    try {
      const {data} = await Vue.http.get(ENDPOINTS.GET_ALL_COINS) ;
      if(data.status == 'success'){
        return data.payload;
      }
      else{
        return []
      }
      
  } catch (error) {
      resolveRequestError(error);
  }
  }


  
  //====================== update coin details =============================//
  
  static async updateCoin(coin ){
    try {
      const {data} = await Vue.http.patch(ENDPOINTS.UPDATE_INDIVIDUAL_COIN +'/'+ coin.id, coin) ;
      if(data.status == 'success'){
        return data.payload;
      }
      else{
        return []
      }
      
  } catch (error) {
      resolveRequestError(error);
  }
  }

  
  
  //====================== update coin rates =============================//
  
  static async updateCoinRate(rate ){
    try {
      const {data} = await Vue.http.put(ENDPOINTS.UPDATE_COIN_RATE +'/'+ rate.id, rate) ;
      if(data.status == 'success'){
        return data.payload;
      }
      else{
        return []
      }
      
  } catch (error) {
      resolveRequestError(error);
  }
  }

   
  //====================== delete coin rate =============================//
  
  static async deleteCoinRate(rate ){
    try {
      const {data} = await Vue.http.delete(ENDPOINTS.DELETE_COIN_RATE +'/'+ rate.id) ;
      if(data){
        return data;
      }
      else{
        return {}
      }
      
  } catch (error) {
    console.error(error)
      resolveRequestError(error);
  }
  }

  
  
  //====================== create coin rates =============================//
  
  static async createCoinRate(rate , coinId){
    try {
      const {data} = await Vue.http.post(ENDPOINTS.ADD_COIN_RATE +'/'+ coinId, rate) ;
      if(data.status == 'success'){
        return data.payload;
      }
      else{
        return []
      }
      
  } catch (error) {
      resolveRequestError(error);
  }
  }

  
  //====================== load coin trades =============================//
  
  static async loadCoinTrades(filter){
    try {
      const query = `?search=${filter.search || ''}&coin_short_name=${filter.coin_short_name || ''}&end_date=${filter.end_date || ''}&start_date=${filter.start_date || ''}&status=${filter.status || ''}&limit=${filter.limit}&page=${filter.page}`;
      const {data} = await Vue.http.get(ENDPOINTS.RETRIEVE_COIN_TRADES + query ) ;
      if(data.status == 'success'){
        return data.payload;
      }
      else{
        return []
      }
      
  } catch (error) {
      resolveRequestError(error);
  }
  }

   
  //====================== close coin trades =============================//
  
  static async closeCoinTrade(trade){
    try {
    const {data} = await Vue.http.patch(ENDPOINTS.TRADE_ACTION, trade ) ;
      if(data.status == 'success'){
        return{data: data.payload, status: 'success'};
      }
      else{
        return []
      }
      
  } catch (error) {
    return {status:'failed',data: error.response}
    //  resolveRequestError(error.response);
  }
  }

    //====================== Retrieve Approval Conditions =============================//
  
    static async retrieveSetting(){
      try {
      const {data} = await Vue.http.get(ENDPOINTS.GET_SETTINGS ) ;
        if(data.status == 'success'){
          return data.payload;
        }
        else{
          return []
        }
        
    } catch (error) {
        resolveRequestError(error);
    }
    }
  //====================== Set Approval Condition =============================//
  
  static async setSettings(settings){
    try {
    const {data} = await Vue.http.post(ENDPOINTS.SET_SETTINGS, settings ) ;
      if(data.status == 'success'){
        return data.payload;
      }
      else{
        return []
      }
      
  } catch (error) {
      resolveRequestError(error);
  }
  }

  //====================== GET COIN TRADE SUMS =============================//
  
  static async tradeSums({startDate, endDate}){
    try {
    const {data} = await Vue.http.get(ENDPOINTS.TRADE_SUM, {
      params: {
        startDate,
        endDate
      }
    });
      if(data.status){
        return data.payload;
      }
      else{
        return []
      }
      
  } catch (error) {
      resolveRequestError(error);
  }
  }

   //====================== GET COIN STATS =============================//
  
   static async coinStats({startDate, endDate}){
    try {
    const {data} = await Vue.http.get(ENDPOINTS.COIN_STATS, {
      params: {
        startDate,
        endDate
      }     
    });
      if(data.status){
        return data.payload;
      }
      else{
        return []
      }
      
  } catch (error) {
      resolveRequestError(error);
  }
  }

    //====================== GET RETRIEVE RATES =============================//
  
    static async retrieveRates(){
      try {
      const {data} = await Vue.http.get(ENDPOINTS.COINRATES ) ;
        return data;
       
        
    } catch (error) {
        resolveRequestError(error);
    }
    }

    
    //====================== UPDATE DOLLAR RATES =============================//
  
    static async updateDollarRates(resp){
      try {
      const {data} = await Vue.http.patch(ENDPOINTS.COINRATES , resp) ;
        return data;
       
        
    } catch (error) {
        resolveRequestError(error);
    }
    }


}